/**
 * Async operations queue
 */
let _cancellationHandlerMap = new Map();

const MAX_DELAYED_ACTIONS = 3000;

/**
 *
 */
const runAllCancellationHandlers = () => {
  const handlers = Array.from(_cancellationHandlerMap.values());
  for (const cancellationHandler of handlers) {
    cancellationHandler();
  }
  _cancellationHandlerMap.clear();
};

/**
 *
 * @param {Function} action
 * @param {number} interval The time, in milliseconds that the timer should wait before the specified action is executed
 * @param {*} args
 */
const delayed = (action, interval = 0, ...args) => {
  if (action === undefined) {
    throw new Error('Invalid action to call');
  }

  if (interval <= 0) {
    throw new Error('Invalid interval. Value must be numeric and greater than 0');
  }

  if(_cancellationHandlerMap.size > MAX_DELAYED_ACTIONS){
    throw new Error('Too many delayed actions queued. Check if you are calling a delayed function too often.');
  }

  const handler = setTimeout(()=>{
    action?.apply(null, [...args]);
    _cancellationHandlerMap.delete(handler);
  }, interval);

  const cancellationHandler = () => { clearTimeout(handler); }
  _cancellationHandlerMap.set(handler, cancellationHandler);

  return cancellationHandler;
}


export { delayed , runAllCancellationHandlers};